export default __webpack_public_path__ + "static/media/d8f7f206ba406ba4fbf7f6db833993771598979851501.1fbefda2.webp";